import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import withModal from "../withModal";

import MaterialModal from "../MaterialModal";
import ScheduleLog from "../../schedule/logs/ScheduleLog";

const ScheduleLogModal = ({ modalProps, isOpen }) => {
    const dispatch = useDispatch();

    const hide = () => {
        dispatch(hideModal("SCHEDULE_LOG"));
    };

    return (
        <MaterialModal
            id="schedule-log-modal"
            isOpen={isOpen}
            onClose={hide}
            title={"Schedule Action Log"}
            showPrimaryButton={false}
            cancelButtonText="Close"
            fullWidth={true}
        >
            <ScheduleLog
                key={modalProps.scheduleId}
                id={modalProps.scheduleId}
                isModal
                name={modalProps.name ? modalProps.name : ""}
            />
        </MaterialModal>
    );
};

ScheduleLogModal.propTypes = {
    modalProps: PropTypes.any,
    isOpen: PropTypes.bool,
};

export default withModal(ScheduleLogModal, "SCHEDULE_LOG");
